'use strict'

import {Button} from "../Button";
import {BaseElement} from "../../BaseElement";

export class IconTextLong extends Button {
  #iconElement = null;
  constructor(text) {
    super(text);
    this.addClass('icon-text-long');
    this.#iconElement = new BaseElement('div')
        .addClass('icon')
        .appendTo(this.DOMElement);
  }

  addIconSrc(url) {
    this.#iconElement.src = url;

    return this;
  }

  addIconClass(value) {
    value ? this.#iconElement.addClass(value) : null;

    return this;
  }
}